import { Navigate, Outlet, useLocation } from "react-router";
import { ErrorBanner, Loading } from "@/components/ui/feedback";
import { useMe } from "../api/session";
import { OfflineScreen } from "../pwa/OfflineScreen";
import { isNetworkError } from "../pwa/online";

export function RequireSession() {
  const me = useMe();
  const location = useLocation();
  // Sem rede: a consulta fica pausada (aparelho offline) ou falha sem resposta. Nos dois casos, a moldura do Nora.
  const offline = (me.isPending && me.fetchStatus === "paused") || (me.isError && isNetworkError(me.error));
  if (offline)
    return <OfflineScreen onRetry={() => void me.refetch()} retrying={me.fetchStatus === "fetching"} />;
  if (me.isPending) return <Loading />;
  if (me.isError) return <ErrorBanner error={me.error} />;
  if (!me.data) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/entrar?next=${encodeURIComponent(next)}`} replace />;
  }
  return <Outlet />;
}
